<template>
  <div v-if="targetIsLoading || historyIsLoading" style="padding: var(--space-base)">
    <v-skeleton-loader type="article" />
  </div>
  <form-layout v-else :title="target?.name ?? 'Sync Details'" @on-dismiss="dismiss">
    <batch-sync-history-item :item="mostRecentRun" />
    <v-spacer />
    <vs-text v-if="previousRuns.length > 0" type="intro" bold style="margin: var(--space-base) 0"
      >Previous Syncs</vs-text
    >
    <div v-for="(item, index) in previousRuns">
      <v-divider v-if="index > 0" />
      <batch-sync-history-item :item="item" :collapsed="true" />
    </div>
    <div v-if="isError">
      <vs-text type="error">Error loading sync history.</vs-text>
    </div>
  </form-layout>
</template>

<script setup lang="ts">
import { computed, ref, toRef } from 'vue'
import FormLayout from '@/components/common/FormLayout.vue'
import VsText from '@/components/vision/VsText.vue'
import { useInvoiceSyncTargetHistoryQuery, useInvoiceSyncTargetsQuery } from '@/api/invoice'
import BatchSyncHistoryItem from '@/components/batches/BatchSyncHistoryItem.vue'
import _ from 'lodash'

const props = defineProps<{
  batchId: string
  targetId: string
}>()
const emit = defineEmits<{
  (e: 'dismiss')
}>()

const dismiss = () => {
  emit('dismiss')
}

const batchIdRef = toRef(props, 'batchId')
const targetIdRef = toRef(props, 'targetId')

const { isLoading: targetIsLoading, data: syncTargets } = useInvoiceSyncTargetsQuery(batchIdRef)
const {
  isLoading: historyIsLoading,
  data: history,
  isError,
} = useInvoiceSyncTargetHistoryQuery(batchIdRef, targetIdRef)

const target = computed(() => {
  return syncTargets.value?.find((s) => s.id === targetIdRef.value)
})

const orderedHistory = computed(() => {
  return _.orderBy(history.value, (x) => x.startedAt, 'desc')
})

const mostRecentRun = computed(() => {
  return orderedHistory.value[0]
})

const previousRuns = computed(() => {
  return orderedHistory.value.slice(1)
})
</script>

<style scoped></style>
